import { render, staticRenderFns } from "./EditSearchLink.vue?vue&type=template&id=56f80d76&scoped=true&"
import script from "./EditSearchLink.vue?vue&type=script&lang=js&"
export * from "./EditSearchLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f80d76",
  null
  
)

export default component.exports